import React, { useState, useEffect } from "react";
import { RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";
import "./Accordion.scss";
import { ReactComponent as RadioDoneIcon } from "../assets/icons/RadioDone.svg";
import { Collapse } from "@mui/material";
import axiosWithAuth from "../utils/axiosWithAuth";
import { useTranslation } from "react-i18next";

const AccordionItem = ({
  title,
  description,
  minValue,
  maxValue,
  index,
  expandedIndex,
  onToggle,
  isFirst,
  isLast,
  item,
}) => {
  const isActive = expandedIndex === index;
  return (
    <div
      style={{
        overflow: "hidden",
        ...(isFirst && {
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
        }),
        ...(isLast && {
          borderBottomLeftRadius: "8px",
          borderBottomRightRadius: "8px",
        }),
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px",
          cursor: "pointer",
          backgroundColor: isActive ? "#f0f0f0" : "#fff",
          ...(isFirst && {
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
          }),
          ...(isLast &&
            isActive && {
              borderBottomLeftRadius: "8px",
              borderBottomRightRadius: "8px",
            }),
        }}
        onClick={() => onToggle(index, item)}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          {isActive ? (
            <RadioDoneIcon
              style={{ marginRight: "10px", width: "20px", height: "20px" }}
            />
          ) : (
            <input
              type="radio"
              checked={false}
              readOnly
              style={{
                marginRight: "10px",
                width: "14px",
                height: "14px",
                accentColor: "currentColor",
                transform: "scale(1.2)",
              }}
            />
          )}
          <span
            style={{
              fontWeight: 500,
              fontSize: 14,
            }}
          >
            {title} ({minValue || "-"}-{maxValue || "-"} AZN)
          </span>
        </div>
        <div className="accordion-icon">
          {isActive ? (
            <RiArrowUpSLine className="accordion-arrow" />
          ) : (
            <RiArrowDownSLine className="accordion-arrow" />
          )}
        </div>
      </div>

      <Collapse in={isActive} disablePortal>
        <div
          style={{
            backgroundColor: "#f9f9f9",
            padding: "10px",
            ...(isLast && {
              borderBottomLeftRadius: "8px",
              borderBottomRightRadius: "8px",
            }),
          }}
        >
          <p
            style={{
              fontWeight: 400,
              fontSize: "10px",
              lineHeight: "1.4",
              marginTop: "5px",
              color: "#111827",
            }}
          >
            {description}
          </p>
        </div>
      </Collapse>
    </div>
  );
};

const Accordion = ({ showError }) => {
  const { i18n } = useTranslation();
  const [repairTariffs, setRepairTariffs] = useState([]);
  const [selectedRepairTariff, setSelectedRepairTariff] = useState(
    JSON.parse(sessionStorage.getItem("selectedRepairTariff")) || null
  );
  const [expandedIndex, setExpandedIndex] = useState(null);

  useEffect(() => {
    axiosWithAuth()
      .get("/repair-tariffs")
      .then((response) => {
        setRepairTariffs(response.data);
      })
      .catch((error) => {
        console.error("Error fetching repair tariffs:", error);
      });
  }, [i18n.language]);

  useEffect(() => {
    if (selectedRepairTariff) {
      const index = repairTariffs.findIndex(
        (item) => item.id === selectedRepairTariff.id
      );
      setExpandedIndex(index);
    }
  }, [repairTariffs, selectedRepairTariff]);

  const handleToggle = (index, item) => {
    if (expandedIndex === index) {
      setExpandedIndex(null);
      setSelectedRepairTariff(null);
      sessionStorage.removeItem("selectedRepairTariff");
    } else {
      setExpandedIndex(index);
      setSelectedRepairTariff(item);
      sessionStorage.setItem("selectedRepairTariff", JSON.stringify(item));
    }
  };

  return (
    <div className="accordion-container"
      style={{
        borderRadius: "8px",
        overflow: "hidden",
        border:
          showError && !sessionStorage.getItem("selectedRepairTariff")
            ? "1px solid red"
            : "1px solid #ddd",
      }}
    >
      {repairTariffs.map((item, index) => (
        <AccordionItem
          key={index}
          title={item.name.text}
          description={item.description.text}
          minValue={item.minValue}
          maxValue={item.maxValue}
          index={index}
          expandedIndex={expandedIndex}
          onToggle={handleToggle}
          isFirst={index === 0}
          isLast={index === repairTariffs.length - 1}
          item={item}
        />
      ))}
    </div>
  );
};

export default Accordion;
